<template>
    <div class="">
        <Wait_Skeleton v-if="!IsWait" />

        <Card class="h-100" v-if="IsWait">
            <template #title> </template>
            <template #content>

                <div class="grid flex justify-content-center flex-wrap">
                    <!-- 1. Kolon -->
                    <div class="col-10">
                        <div class="grid">

                            <div class="col-12 flex items-center borderstart">
                                <div class="grid">
                                    <div class="col-1 flex align-items-center justify-content-center">
                                        <Checkbox v-model="Mail" inputId="Mail" :binary="true" size="large" />
                                    </div>
                                    <div class="col-11">
                                        <div class="grid">
                                            <div class="col-12 IzinBaslik">E-Posta</div>
                                            <div class="col-12 IzinAciklama">İlgimi çekebilecek kampanyalarla ve ilgili
                                                e-posta almak istiyorum.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 flex items-center bordercenter">
                                <div class="grid">
                                    <div class="col-1 flex align-items-center justify-content-center">
                                        <Checkbox v-model="Sms" inputId="SMS" :binary="true" size="large" />
                                    </div>
                                    <div class="col-11">
                                        <div class="grid">
                                            <div class="col-12 IzinBaslik font-semibold">SMS</div>
                                            <div class="col-12 IzinAciklama">İlgimi çekebilecek kampanyalarla ve ilgili
                                                sms almak istiyorum.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 flex items-center borderend">
                                <div class="grid">
                                    <div class="col-1 flex align-items-center justify-content-center">
                                        <Checkbox v-model="Telefon" inputId="Telefon" name="Telefon" value="Telefon"
                                            :binary="true" size="large" />
                                    </div>
                                    <div class="col-11">
                                        <div class="grid">
                                            <div class="col-12 IzinBaslik font-semibold">Telefon Görüşmesi</div>
                                            <div class="col-12 IzinAciklama">İlgimi çekebilecek kampanyalarla ve ilgili
                                                telefon görüşmesi yapmak istiyorum.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <Divider />
                    <div class="col-12 flex justify-content-end flex-wrap">
                        <IslemYapiliyor v-if="IslemYapiliyor" />
                        <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small"
                            severity="success" @click="this.handleClick()" autofocus :disabled="IslemYapiliyor"
                            v-if="!IslemYapiliyor" />
                    </div>
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import GlobalServis from "../../../../../services/GlobalServis";

export default {
    data() {
        return {
            IslemYapiliyor: false,
            IsWait: false,

            Mail: false,
            Sms: false,
            Telefon: true,
        }
    },
    methods: {
        handleClick() {
            this.IslemYapiliyor = true;

            let data = {
                MailIzin: this.Mail,
                SmsIzin: this.Sms,
                TelefonIzin: this.Telefon
            };

            GlobalServis.GlobalServis("POST", "UpdateDuyuruIzin", data).then((res) => {
                if (res.status == 200) {
                    this.$toast.add({
                        severity: "success",
                        summary: "Başarılı",
                        detail: "Duyuru tercihleri güncellenmiştir.",
                        life: 3000,
                    });
                } else if (res.response.status === 999) {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Uyarı",
                        detail: res.response.data,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Hata oldu",
                        life: 3000,
                    });
                }
            }).then(() => {
                this.IslemYapiliyor = false;
            });


        },
        _GetGetDuyuruIzin() {
            GlobalServis.GlobalServis("GET", "GetDuyuruIzin", "").then((res) => {
                if (res.status == 200) {
                    this.Mail = res.data[0].MailIzin;
                    this.Sms = res.data[0].SmsIzin;
                    this.Telefon = res.data[0].TelefonIzin;
                } else if (res.response.status === 999) {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Uyarı",
                        detail: res.response.data,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Hata oldu",
                        life: 3000,
                    });
                }
            })
        },
        _ResetForm() {

        },
    },
    created() {
        this._GetGetDuyuruIzin();
        this.IsWait = true;
    },
    components: {
    },

}
</script>
<style scoped lang="scss">
.borderstart {
    border-style: solid;
    border-color: #32de8a;
    border-width: 2px 2px 0.1px 2px;
    border-radius: 10px 10px 0px 0px;
}

.bordercenter {
    border-style: solid;
    border-color: #32de8a;
    border-width: 0.1px 2px 0.1px 2px;
}

.borderend {
    border-style: solid;
    border-color: #32de8a;
    border-width: 0.1px 2px 2px 2px;
    border-radius: 0px 0px 10px 10px;
}

.IzinBaslik {
    font-weight: 700;
    color: #044389;
}

.IzinAciklama {
    font-weight: 500;
}
</style>